import { atom, selector, selectorFamily } from "recoil"
import { ImageUtils } from "../framework/utils"
import { Carousel } from "../models/Carousel"
import apiService from "../services/api"
import api from "../services/api"

export const defaultCarousel: Carousel = {
    id: 0,
    createdAt: null,
    updatedAt: null,
    title: '',
    argument: '',
    payload: 'TBD',
    buttonText: '',
    imageFile: null,
    fileEncoded: '',
    link: '',
    imageUrl: '',
    color: '',
    imageType: 'F',
    imageOnly: true,
    ordering: 0
}

export const carouselRequestNumberState = atom({
    key: 'carouselRequestNumberState',
    default: 1
})

export const carouselAll = selector({
    key: 'carouselAll',
    get: async ({get}) => {
        
        get(carouselRequestNumberState)
        
        let carous: Carousel[] = []
        const rv = await api.getAllCarousel()
        if (!rv) return carous
        return rv
    }
})

export const carouselAtom = atom<Carousel>({
    key: 'carouselAtom',
    default: defaultCarousel
})

// export const carouselListAtom = atom<Carousel[]>({
//     key: 'carouselListAtom',
//     default: [],
// })

export const carouselImageSelector = selectorFamily({
    key: 'carouselImageSelector',
    get: (id: number) =>  async ({ get }) => {
        if (id === 0) return '';
        let result: string = ''        
        get(carouselRequestNumberState)
        //const news = get(newsAtom)
        const ns = await apiService.getCarousel(id)
        if (ns && ns.fileEncoded) {
            result = ImageUtils.fromBase64ToDataUrl(ns.fileEncoded, 'png')
        }
        return result;
    }
})

//Used for update
// export const updateCarouselSelector = selector<Carousel>({
//     key: 'updateCarouselSelector',
//     get: ({get}) => {
//         //const myList = get(newsListAtom).map(x => x)
//         //let rv = myList.find(x => x.id === item.id)
//         const rv = get(carouselAtom)
//         return rv
//     },
//     set: ({get, set}, newValue) => {
//         if (!(newValue instanceof DefaultValue)) {
//             if (newValue) {
//                 const newSd = newValue as Carousel
//                 const lista = get(carouselListAtom)
//                 const ele = lista.find(x => x.id === newSd.id)
//                 if (ele) {
//                     //Sostituisco il News nell'indice
//                     const idx = lista.findIndex(x => x.id === ele.id)
//                     if (idx >= 0) {
//                         const newLista = [...lista.slice(0, idx), newSd, ...lista.slice(idx + 1)]
//                         set(carouselListAtom, newLista)
//                     }
//                 }
//             }
//         }
//     }
// })

//For Add
// export const addCarouselSelector = selector<Carousel>({
//     key: 'addCarousel',
//     get: ({get}) => {
//         //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
//         return get(carouselAtom)
//     },
//     set: ({get, set}, itemAdd) => {
//         set(carouselListAtom, [...get(carouselListAtom), itemAdd as Carousel])
//     },
// })

// //For Delete
// export const deleteCarouselSelector = selector<Carousel>({
//     key: 'deleteCarouselSelector',
//     get: ({get}) => {
//         //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
//         return get(carouselAtom)
//     },
//     set: ({get, set}, itemToRemove) => {
//         // console.log('setting news removed')
//         let myNewList = get(carouselListAtom).filter(x => x.id !== (itemToRemove as Carousel).id)
//         set(carouselListAtom, myNewList)
//     },
// })

